import { FinanceAuditEvent } from '../../types/finance';

const str = (v: unknown) => (v == null || v === '' ? '' : String(v));

/** One line per finance audit event. */
export const describeFinanceEvent = (e: FinanceAuditEvent): string => {
  const v = e.newValue ?? {};
  const payment = e.paymentNumber ? `${e.paymentNumber}: ` : '';
  switch (e.action) {
    case 'PAYMENT_ADDED':
      if (v.resubmissionOf)
        return `${payment}corrected and resubmitted for approval (replaces rejected ${str(v.resubmissionOf)}) — ${str(v.currency)} ${Number(v.amount ?? 0).toFixed(2)}`;
      return `${payment}recorded ${str(v.category)}${v.type && v.type !== 'PAYMENT' ? ` (${str(v.type).toLowerCase()})` : ''} — ${str(v.currency)} ${Number(v.amount ?? 0).toFixed(2)}${v.taxAmount ? ` + SSCL ${Number(v.taxAmount).toFixed(2)}` : ''}`;
    case 'EDITED': {
      if (v.slipUploaded)
        return `${payment}payment slip uploaded${v.originalName ? ` (${str(v.originalName)})` : ''}`;
      const old = e.oldValue ?? {};
      const changes = Object.keys(v).map(
        (k) => `${k}: ${str(old[k]) || '—'} → ${str(v[k]) || '—'}`,
      );
      return `${payment}edited${changes.length ? ` — ${changes.join(', ')}` : ''}`;
    }
    case 'APPROVED':
      return `${payment}payment approved${v.receiptUploaded === false ? ' (no slip uploaded)' : ''}`;
    case 'REJECTED':
      return `${payment}payment rejected${v.reason ? ` — reason: ${str(v.reason)}` : ''}`;
    case 'DOCUMENT_GENERATED':
    case 'DOCUMENT_REGENERATED':
      return `Invoice ${str(v.invoiceNumber)} generated`;
    case 'DOCUMENT_DOWNLOADED': {
      const doc = str(v.document ?? v.documentType).toLowerCase();
      const number = str(v.invoiceNumber ?? v.receiptNumber);
      return `${payment}${doc || 'document'}${number ? ` ${number}` : ''} downloaded`;
    }
    case 'DOCUMENT_SENT':
      return `${str(v.documentType ?? 'Document').toLowerCase()} sent to the student`;
    case 'FEE_CHANGE_REQUESTED':
      return 'Student fee change requested';
    case 'FEE_CHANGE_APPROVED':
      return 'Student fee change approved';
    case 'FEE_CHANGE_REJECTED':
      return 'Student fee change rejected';
    case 'FEE_SYNCED_FROM_DEFAULT':
      return 'Fees re-synced from the university defaults';
    default:
      return `${payment}${e.action.replace(/_/g, ' ').toLowerCase()}`;
  }
};
